import { AssessmentTokenService } from '../../shared/services/assessment-token.service';
import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { AssessmentGroupService } from '../../shared/services/assessment-group.service';
import { AssessmentService } from 'app/shared/services/assessment.service';
import { AuthService } from 'app/login/services/auth.service';
import { Capability } from 'app/shared/models/capability';
var AssessmentTokensListComponent = /** @class */ (function () {
    function AssessmentTokensListComponent(tokenService, assessmentGroupService, assessmentService, authService) {
        var _this = this;
        this.tokenService = tokenService;
        this.assessmentGroupService = assessmentGroupService;
        this.assessmentService = assessmentService;
        this.authService = authService;
        this.buy = new EventEmitter();
        this._loaded = false;
        this.canShop = false;
        this._userSubscription = this.authService.getLoginState().subscribe(function (loginState) {
            if (loginState.user) {
                _this.canShop = loginState.user.hasCapability(Capability.CAN_SHOP);
            }
            else {
                _this.canShop = false;
            }
        });
    }
    AssessmentTokensListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._loaded = false;
        Promise.all([
            this.tokenService.loadAssessmentTokens(),
            this.assessmentGroupService.getAssessmentGroups(),
            this.assessmentService.getAssessmentList(),
        ])
            .then(function (results) {
            var groups = results[1], assessments = results[2];
            _this.groupTokenItems = groups.map(function (g) { return { name: g.Name, quantity: _this.tokenService.getGroupRemainingTokens(g) }; });
            _this.tokenItems = assessments.map(function (a) { return { name: a.name, quantity: _this.tokenService.getRemainingTokens(a) }; });
            _this._loaded = true;
        })
            .catch(function (error) {
            console.error(error);
            _this._loaded = true;
        });
    };
    AssessmentTokensListComponent.prototype.ngOnDestroy = function () {
        this._userSubscription.unsubscribe();
    };
    Object.defineProperty(AssessmentTokensListComponent.prototype, "loaded", {
        get: function () {
            return this._loaded;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentTokensListComponent.prototype.triggerBuy = function (item) {
        this.buy.emit(item);
    };
    AssessmentTokensListComponent.prototype.shouldBuyTokens = function (item) {
        return this.canShop && item.quantity <= 0;
    };
    return AssessmentTokensListComponent;
}());
export { AssessmentTokensListComponent };



// WEBPACK FOOTER //
// ./src/app/admin/assessment-tokens-list/assessment-tokens-list.component.ts.pre-build-optimizer.js